import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../components/Slider/loader";
// import { IoCallOutline} from "react-icons/io";

const ContactUs = () => {
  const [loader, setLoader] = useState();
  const [isProgress, setIsProgress] = useState(false);
  const [text, setText] = useState("");
  console.log(text && text.number, "text text");

  const pStyle = {
    margin: "4px 0",
    fontSize: "13px",
    lineHeight: "1.4",
  };

  const titleStyle = {
    margin: "4px 0",
    fontSize: "14px",
    fontWeight: 600,
  };

  const contactUs = async () => {
    setLoader(true);
    try {
      const response = await axios.get(`user/setting/helpline/view`);
      if (response.data.success) {
        setText(response.data.data);
      } else {
        alert("error cancellation Policy api call");
      }
      console.log(response);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    contactUs();
  }, []);

  return (
    <div style={styles.bgBody}>
      {loader && loader ? (
        <div className="position-loader">
          <Loader />
        </div>
      ) : (
        <div style={styles.bgBodyInner}>
          <div style={{ backgroundColor: "#fff", height: "100%" }}>
            <div style={styles.bgCard}>
              <div style={styles.aboutTextSection}>
                <div style={{ width: "60%" }}>
                  <p style={styles.pageNameText}>
                    Aivimart Help Center | 24x7 Customer Care Support
                  </p>
                  <p>Please get in touch and we will be happy to help you</p>

                  <div>
                    <p style={titleStyle}>
                      Address of Principal Place of Business
                    </p>

                    <p style={pStyle}>
                      <strong>Floor No.:</strong> 0
                    </p>
                    <p style={pStyle}>
                      <strong>Building No./Flat No.:</strong> 1/4 OPPOSITE
                      VIVANTA BY TAJ
                    </p>
                    <p style={pStyle}>
                      <strong>Name of Premises/Building:</strong> SUDHALATA
                      APARTMENT
                    </p>
                    <p style={pStyle}>
                      <strong>Road/Street:</strong> KHANAPARA ROAD
                    </p>
                    <p style={pStyle}>
                      <strong>Nearby Landmark:</strong> Vivanta Guwahati
                    </p>
                    <p style={pStyle}>
                      <strong>Locality/Sub Locality:</strong> Khanapara
                    </p>
                    <p style={pStyle}>
                      <strong>City/Town/Village:</strong> Guwahati
                    </p>
                    <p style={pStyle}>
                      <strong>District:</strong> Kamrup Metropolitan
                    </p>
                    <p style={pStyle}>
                      <strong>State:</strong> Assam
                    </p>
                    <p style={(pStyle, { marginBottom: 20 })}>
                      <strong>PIN Code:</strong> 781022
                    </p>
                  </div>
                  <a
                    href={"tel:+919181341366"}
                    style={{
                      backgroundColor: "#ffc000",
                      paddingRight: 30,
                      paddingLeft: 30,
                      paddingBottom: 7,
                      paddingTop: 7,
                      fontSize: 16,
                      borderRadius: 5,
                      fontWeight: "500",
                      color: "#000",
                      textDecoration: "none",
                    }}
                  >
                    {" "}
                    Call Us
                  </a>
                </div>
                <div style={{ width: "40%", marginTop: 50 }}>
                  <img src={require("../../assets/contact.png")} />
                </div>
                {/* <p> {ReactHtmlParser(text)}</p> */}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Divider */}
      <div style={styles.divider}></div>
    </div>
  );
};

export default ContactUs;
const styles = {
  divider: { padding: 40 },
  bgBody: { height: "100%" },
  bgBodyInner: {
    paddingLeft: 80,
    paddingRight: 80,
    textAlign: "justify",
    paddingTop: 20,
  },
  pageNameText: {
    fontSize: 26,
    color: "#000000",
    fontWeight: "bold",
    marginTop: 10,
    paddingTop: 20,
  },
  bgCard: {
    marginHorizontal: 10,
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: "#ddd",
    padding: 10,
  },
  aboutTextSection: { padding: 10, display: "flex", columnGap: 80 },
};
